import { ChangeEvent, useEffect, useMemo, useRef, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { FerramentasDeDetalhe, RadioGroup, ILstLiga } from "../../shered/components";
import { useNavigate, useParams } from "react-router-dom";
import { VForm, VTextField, useVForm } from "../../shered/forms";
import {
    Box, Button, Icon,
    FormControl,
    InputLabel,
    MenuItem,
    Select, Tab, Tabs,
    Paper, Typography, useTheme,
    TextField,
    Card,
    CardActionArea,
    CardContent,
    Tooltip,
    Snackbar,
    Alert,
    Autocomplete,
    CircularProgress
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import { DataGrid, GridActionsCellItem, GridColDef, GridRowParams } from "@mui/x-data-grid";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { Loading } from "../../shered/components/loading/Loading";
import { ILstDrop, UtilidadeService, enumFormasPagamento, statusFinanceiro, tipoDisponibilizacaoJogador, tiposLiga } from "../../shered/services/api/utilidades/UtilidadesService";
import { FinanceiroService, IDadosBaixaFinanceiro, IDadosCreateFinanceiro, IDadosPagamentoLiga, IDadosPremiacao, IDadosSalvarArquivos, IListaDadosCadastroFinanceiro, IListaDadosDetalheFinanceiro, IListaDadosFinanceiro } from "../../shered/services/api/financeiro/FinanceiroService";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styled from "@emotion/styled";
import { VTextMaskCPF } from "../../shered/forms/VTextMaskCPF";
import QRCode from "react-qr-code";
import { Download, FileCopy, RssFeed } from "@mui/icons-material";
import { UsuarioService, IListaIndicacao, IListaIndicados } from "../../shered/services/api/usuario/UsuarioService";
import dayjs, { Dayjs } from "dayjs";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ?
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {
                    // value === index && (
                    <Box sx={{ p: UtilidadeService.isMobile() ? 0 : 3 }}>
                        <Grid container>{children}</Grid>
                    </Box>
                    //)
                }
            </div>
            : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

interface IDadosPagamento {
    codigo?: number;
    valorSemDesconto: number;
    desconto: number;
    descontoDado: number;
    valorTotal: number;
    valorPago: number;
    qtdLigaSelecionada: number;
    qtdLiga: number;
    premiacao: number;
    valorLiga: number;
}

export const ListagemDeFinanceiro: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    const { themeName } = useAppThemeContext();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const buttonRef = useRef(null);
    let codLocal = localStorage.getItem("@codigoLiga");
    const { id } = useParams<"id">();
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [detalheFinanceiro, setDetalheFinanceiro] = useState<IListaDadosFinanceiro>();
    const [showDetalheFinanceiro, setShowDetalheFinanceiro] = useState(false);
    const [showDetalheFinanceiroHistorico, setShowDetalheFinanceiroHistorico] = useState(false);
    const [showDetalheIndicados, setShowDetalheIndicados] = useState(false);
    const [showDetalheIndicacao, setShowDetalheIndicacao] = useState(false);
    const [lstIndicacao, setLstIndicacao] = useState<IListaIndicados[]>([]);
    const [lstIndicados, setLstIndicados] = useState<IListaIndicacao[]>([]);


    const [comissarioLiga, setComissarioLiga] = useState(false);
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [value, setValue] = useState(0);
    const [codigoUsuarioFiltroIndicacao, setCodigoUsuarioFiltroIndicacao] = useState(0);
    const [codigoTemporadaFiltro, setCodigoTemporadaFiltro] = useState(0);
    const [codigoTemporadaFiltroHistorico, setCodigoTemporadaFiltroHistorico] = useState(0);
    const [codigoTemporadaFinanceiroFiltro, setCodigoTemporadaFinanceiroFiltro] = useState(0);
    const [codigoTemporadaFiltroIndicacao, setCodigoTemporadaFiltroIndicacao] = useState(0);
    const [codigoTipoLigaFiltro, setCodigoTipoLigaFiltro] = useState(0);
    const [codigoTipoLigaFiltroHistorico, setCodigoTipoLigaFiltroHistorico] = useState(0);
    const [voltarAdm, setVoltarAdm] = useState(false);
    const [possuiArquivo, setPossuiArquivo] = useState(false);
    const [showBotaoCancelar, setShowBotaoCancelar] = useState(false);
    const [limparFiltros, setLimparFiltros] = useState(false);
    // const [files, setFiles] = useState<File[]>([]);
    const [files, setFiles] = useState<IDadosSalvarArquivos[]>([]);
    const [dadosPagamento, setDadosPagamento] = useState<IDadosPagamento>();
    const [descontoComissario, setDescontoComissario] = useState(false);
    const [residenciaExterior, setResidenciaExterior] = useState(false);

    const [descontoIndicacao, setDescontoIndicacao] = useState(false);

    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [codigoTemporadaHistorico, setCodigoTemporadaHistorico] = useState(0);
    const [codigoUsuario, setCodigoUsuario] = useState(0);

    const [valorTabela, setValorTabela] = useState(0);
    const [desativar, setDesativar] = useState(false);
    const [showBotaoGerarSolicitacao, setShowBotaoGerarSolicitacao] = useState(false);
    const [showBotaoContatoWhatsApp, setShowBotaoContatoWhatsApp] = useState(false);

    const [userAdm, setUserAdm] = useState(false);
    const [formaPagamento, setFormaPagamento] = useState(2);
    const [cpf, setCpf] = useState("");
    const [nomeCompleto, setNomeCompleto] = useState("");
    const [valorPago, setValorPago] = useState(0);
    const [descontoRecebido, setDescontoRecebido] = useState(0);
    const [lstLiga, setLstLiga] = useState<ILstLiga[]>([]);
    const [qtdPago, setQtdPago] = useState(0);
    const [premiacaoAnel, setPremiacaoAnel] = useState(0);
    const [valorPremiacaoAnel, setValorPremiacaoAnel] = useState(0);
    const [valorPremiacaoUsuario, setValorPremiacaoUsuario] = useState(0);
    const [premiacaoFunko, setPremiacaoFunko] = useState(0);
    const [valorPremiacaoFunko, setValorPremiacaoFunko] = useState(0);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [lstTemporadasAtual, setLstTemporadasAtual] = useState<ILstDrop[]>([]);
    const [arquivos, setArquivos] = useState<any[]>([]);
    const [listaLigas, setListaLigas] = useState<any[]>([]);
    const [opcoesAutoCompleteUsuario, setOpcoesAutoCompleteUsuario] = useState<ILstDrop[]>([])
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [lstFinanceiro, setLstFinanceiro] = useState<IListaDadosDetalheFinanceiro[]>([]);
    const [lstFinanceiroHistorico, setLstFinanceiroHistorico] = useState<IListaDadosDetalheFinanceiro[]>([]);
    const [lstPremiacao, setLstPremiacao] = useState<IDadosPremiacao[]>([]);
    const [lstPremiacaoHistorico, setLstPremiacaoHistorico] = useState<IDadosPremiacao[]>([]);
    const [codigoLigaSelecionado, setCodigoLigaSelecionado] = useState(0);
    const [lstFinanceiroComissario, setLstFinanceiroComissario] = useState<IListaDadosDetalheFinanceiro[]>([]);
    const [lstDetalhePagamentoLiga, setLstDetalhePagamentoLiga] = useState<IDadosPagamentoLiga[]>([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ralizar o pagamento? ",
        display: "none",
        titulo: "Atenção"
    });

    useEffect(() => {
        let codLiga = codigoLiga;
        setLimparFiltros(false);
        setIsLoading(true);
        setRemoveLoading(false);
        handleCarregarUsuarios(true);
        CarregarDadosIndicacao(null);
        const fetchData = async () => {
            let codTempAtual = 0;
            let codUsuario = user.codUsuario;
            if (id !== null && id !== undefined && id !== "" && id !== "0") {
                const resultCrypt = UtilidadeService.decrypt(id);
                if (resultCrypt !== "0") {
                    codUsuario = Number(resultCrypt);
                    setVoltarAdm(true);
                }
            }
            setCodigoUsuario(codUsuario);

            await UtilidadeService.getTemporadaAtual()
                .then((result) => {
                    setIsLoading(false);
                    const tmp = result.dado;
                    codTempAtual = tmp.codigo;
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            await UtilidadeService.getTemporadas(true, 0)
                .then((result) => {
                    setIsLoading(false);
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            if (Number(codLiga) > 0) {
                await LigaService.getDadosLigaPeloCodigo(Number(codLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        setComissarioLiga(liga.comissario_Usuario || user.administrador);
                        setIsLoading(false);
                        setRemoveLoading(true);
                        setCodigoTemporada(liga.codigo_Temporada);
                        setCodigoTemporadaFiltro(liga.codigo_Temporada);
                        setCodigoTemporadaFinanceiroFiltro(liga.codigo_Temporada);
                        codTempAtual = liga.codigo_Temporada;
                        if (liga.comissario_Usuario || user.administrador) {
                            let carregar = liga.comissario_Usuario || user.administrador;
                            CarregarDadosFinanceiroLiga(carregar, liga.codigo, liga.codigo_Temporada);
                        }
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setIsLoading(false);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            //setRedirecionar("/ligas");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });

                await LigaService.getAllPorUsuario()
                    .then((result) => {
                        const lst = result.data.dado;
                        let listaDrop: ILstLiga[] = user.administrador ? lst.map(l => ({ codigo: l.codigo, label: l.nome })) : lst.filter(f => f.comissario_Usuario === true).map(l => ({ codigo: l.codigo, label: l.nome }));
                        setLstLiga(listaDrop);
                        setCodigoLigaSelecionado(Number(codLiga));
                        setCodigoLiga(codLiga);
                        CarregarDadosLiga(Number(codLiga));
                        if (!user.pagamentoConcluido) {
                            codLiga = listaDrop.slice(0, 1).map(m => m.codigo).toString();
                            localStorage.setItem("@codigoLiga", codLiga.toString());
                            localStorage.setItem("@codigoUsuFranquia", user.codUsuario);
                        }
                    })
                    .catch((errors) => {
                        if (errors.response.data.statusHTTP === 401) {
                            logout();
                            navigate(0);
                            return;
                        }
                    });
            }
            CarregarDadosFinanceiro(codUsuario, codTempAtual);
        }

        fetchData();
    }, [codigoLiga, limparFiltros]);


    const handleCarregarUsuarios = async (atualizar: boolean) => {
        UsuarioService.getAllDropdownIndicados()
            .then((result) => {
                setIsLoading(false);
                const lst = result.dado;
                if (atualizar) {
                    setOpcoesAutoCompleteUsuario(lst.map(p => ({ codigo: p.codigo, label: p.codigo + " - " + p.nome })));
                }

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados! Favor entrar em contato com a TI",
                    display: "none",
                    titulo: "Atenção"
                });
                return;

            });
    }

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteUsuario.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteUsuario]);

    const CarregarDadosIndicacao = async (codigoUsuarioIndicacao: number | null) => {
        await UsuarioService.getDadosIndicacao(codigoUsuarioIndicacao)
            .then((result) => {
                const dados = result.dado;
                if (dados.length > 0) {
                    setShowDetalheIndicacao(true);
                    setLstIndicacao(dados);
                }
                //setLstIndicados(dados.indicados ?? []);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const CarregarDadosLiga = async (codigoLiga: number) => {
        LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
            .then((result) => {
                const liga = result.dado;
                setDadosLiga(liga);
                if (liga.caminho_Logo !== null) {
                    setShowImagemFranquia(liga.caminho_Logo);
                }
                CarregarTemporadasPorLiga(liga.codigo, liga.codigo_Temporada);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const CarregarTemporadasPorLiga = async (codigoLiga: number, codigoTemporada: number) => {

        await UtilidadeService.getTemporadasLiga(codigoLiga)
            .then((result) => {
                setIsLoading(false);
                const tmps = result.data.dado;
                let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                setLstTemporadasAtual(lstTemporadasAux);
                setCodigoTemporadaFinanceiroFiltro(codigoTemporada);
                CarregarDadosFinanceiroLiga(comissarioLiga, codigoLiga, codigoTemporada);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const CarregarDadosFinanceiro = async (codigoUsuario: number, codigoTemporada: number) => {
        //let codigoUsuario = user.codUsuario;

        await FinanceiroService.getDadosFinanceiroPorUsuario(Number(codigoUsuario), codigoTemporada)
            .then((result) => {
                const dados = result.dado;
                // console.log("dados financeiros");
                // console.log(dados);
                setDetalheFinanceiro(dados);
                setDescontoComissario(dados.desconto_Comissario);
                setDescontoIndicacao(dados.desconto_Indicacao);
                setResidenciaExterior(dados.residencia_Exterior);
                setLstFinanceiro(dados.detalhes_Financeiro_Liga.length > 0 ? dados.detalhes_Financeiro_Liga : []);
                setLstPremiacao(dados.detalhes_Premiacao_Liga.length > 0 ? dados.detalhes_Premiacao_Liga : []);
                setShowDetalheFinanceiro(dados.detalhes_Financeiro_Liga.length > 0);
                setLstDetalhePagamentoLiga(dados.detalhes_Pagamento_Liga.length > 0 ? dados.detalhes_Pagamento_Liga : []);
                //let codTemp = dados.detalhes_Financeiro_Liga.length > 0 ? dados.detalhes_Financeiro_Liga[0].codigo_Temporada : codigoTemporada;

                setCodigoTemporada(codigoTemporada);
                setIsLoading(false);
                setRemoveLoading(true);
                setValorPago(Number(dados.valor_Pago));
                setDescontoRecebido(Number(dados.desconto_Pago));
                setQtdPago(dados.detalhes_Financeiro_Liga.length > 0 ? dados.detalhes_Financeiro_Liga.filter(f => f.status === 5 && f.codigo_Temporada === codigoTemporada).length : 0)
                setValorTabela(Number(dados.valor_Liga));
                if (codigoTemporada > 0) {
                    CarregarArquivosSalvos(Number(codigoUsuario), codigoTemporada);
                }
                setUserAdm(user.administrador);
                let premiacaoAnel = dados.detalhes_Premiacao_Liga.find(f => f.codigo === 1);
                let premiacaoFunko = dados.detalhes_Premiacao_Liga.find(f => f.codigo === 2);
                setPremiacaoAnel(premiacaoAnel !== undefined ? premiacaoAnel.quantidade : 0);
                setValorPremiacaoAnel(premiacaoAnel !== undefined ? premiacaoAnel.valor_Total : 0);
                setValorPremiacaoUsuario(premiacaoAnel !== undefined ? premiacaoAnel.valor_Usuario : 0);
                setPremiacaoFunko(premiacaoFunko !== undefined ? premiacaoFunko.quantidade : 0);
                setValorPremiacaoFunko(premiacaoFunko !== undefined ? premiacaoFunko.valor_Total : 0);
                CarregarDadosFinanceiroHistorico(codigoUsuario);
                const dadosPagamento = dados.detalhes_Pagamento_Liga[0];
                if (dadosPagamento !== undefined && dadosPagamento?.url_Checkout !== null && dadosPagamento?.url_Checkout !== undefined) {
                    handleDirecionarUrlPagamento(dadosPagamento?.url_Checkout);
                }

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const CarregarDadosFinanceiroHistorico = async (codigoUsuario: number) => {

        await FinanceiroService.getDadosFinanceiroPorUsuario(Number(codigoUsuario), codigoTemporadaFiltroHistorico, codigoTipoLigaFiltroHistorico)
            .then((result) => {
                const dados = result.dado;
                // console.log("dados financeiros");
                // console.log(dados);
                //setDetalheFinanceiro(dados);
                setLstFinanceiroHistorico(dados.detalhes_Financeiro_Liga.length > 0 ? dados.detalhes_Financeiro_Liga : []);
                setLstPremiacaoHistorico(dados.detalhes_Premiacao_Liga.length > 0 ? dados.detalhes_Premiacao_Liga : []);
                setShowDetalheFinanceiroHistorico(dados.detalhes_Financeiro_Liga.length > 0);

                //let codTemp = dados.detalhes_Financeiro_Liga.length > 0 ? dados.detalhes_Financeiro_Liga[0].codigo_Temporada : codigoTemporada;

                setCodigoTemporadaHistorico(codigoTemporadaFiltroHistorico);
                setIsLoading(false);
                setRemoveLoading(true);

                if (codigoTemporadaFiltroHistorico > 0) {
                    CarregarArquivosSalvos(Number(codigoUsuario), codigoTemporadaFiltroHistorico);
                }
                setUserAdm(user.administrador);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    }

    const handleSave = async (dados: any) => {
        setDesativar(true);
        setIsLoading(true);
        setRemoveLoading(false);
        const liga = dadosLiga !== null && dadosLiga !== undefined ? dadosLiga : null;
        if (liga === null) {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        //CarregarDadosFreeAgency(codigoFreeAgency, codigoFranquia, newValue);
    };

    const handleCarregarDetalhesFinanceiro = (dadosFinanceiros: IListaDadosDetalheFinanceiro[]) => {
        setLstFinanceiro(dadosFinanceiros);
        setShowDetalheFinanceiro(true);
    }

    const hendleCarregarDadosPorDropLiga = (codigoLiga: number) => {
        //CarregarDadosLiga(codigoLiga);
        CarregarDadosFinanceiroLiga(comissarioLiga, codigoLiga, codigoTemporada);
    }

    const CarregarDadosFinanceiroLiga = async (comissario: boolean, codigoLiga: number, codigoTemporada: number) => {
        if (comissario) {
            await FinanceiroService.getDadosFinanceiroPorLiga(codigoLiga, codigoTemporada)
                .then((result) => {
                    const dados = result.dado;
                    setLstFinanceiroComissario(dados);

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }
    }

    const handleRowsSelection = async (ids: any) => {
        setIsLoading(true);
        setRemoveLoading(false);
        setListaLigas(ids);
        setShowBotaoGerarSolicitacao(ids.length > 0);
        setShowBotaoContatoWhatsApp(ids.length > 0 && residenciaExterior);
        //setFormaPagamento(0);
        let lstPremiacao = lstFinanceiro.filter(f => f.premiacao && ids.includes(f.codigo_Unico));
        let valorPremiacao = lstPremiacao !== undefined && lstPremiacao.length > 0 ? lstPremiacao.reduce((s, obj) => { return s + (obj.valor_Usuario !== undefined ? obj.valor_Usuario : 0) }, 0) : 0;
        let qtdLigas = qtdPago > 0 ? ids.length + qtdPago : ids.length;

        if (qtdLigas > 0 && descontoComissario) {
            await FinanceiroService.getValoresFinanceiro(qtdLigas, 2)
                .then((result) => {
                    let tabela = result.dado;
                    setDadosPagamento({
                        qtdLiga: qtdPago,
                        valorSemDesconto: (tabela.valor_Unitario * qtdPago),
                        descontoDado: descontoRecebido,
                        valorPago: valorPago,
                        qtdLigaSelecionada: ids.length,
                        premiacao: valorPremiacao,
                        valorLiga: tabela.valor_Unitario,
                        desconto: ((qtdLigas * tabela.valor_Unitario) - (qtdLigas * tabela.valor)),
                        valorTotal: valorPremiacao + (qtdLigas <= 4 ? ((ids.length * tabela.valor_Unitario) - ((qtdLigas * tabela.valor_Unitario) - ((qtdLigas * tabela.valor) + descontoRecebido))) : (ids.length * tabela.valor))
                    });
                    setIsLoading(false);
                    setRemoveLoading(true);
                    return;
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os arquivos, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }
        if (qtdLigas > 0 && descontoIndicacao) {
            await FinanceiroService.getValoresFinanceiro(qtdLigas, 3)
                .then((result) => {
                    let tabela = result.dado;
                    setDadosPagamento({
                        qtdLiga: qtdPago,
                        valorSemDesconto: (tabela.valor_Unitario * qtdPago),
                        descontoDado: descontoRecebido,
                        valorPago: valorPago,
                        qtdLigaSelecionada: ids.length,
                        premiacao: valorPremiacao,
                        valorLiga: tabela.valor_Unitario,
                        desconto: ((qtdLigas * tabela.valor_Unitario) - (qtdLigas * tabela.valor)),
                        valorTotal: valorPremiacao + (qtdLigas <= 4 ? ((ids.length * tabela.valor_Unitario) - ((qtdLigas * tabela.valor_Unitario) - ((qtdLigas * tabela.valor) + descontoRecebido))) : (ids.length * tabela.valor))
                    });
                    setIsLoading(false);
                    setRemoveLoading(true);
                    return;
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os arquivos, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }
        else if (qtdLigas > 0 && !descontoComissario && !descontoIndicacao) {
            await FinanceiroService.getValoresFinanceiro(qtdLigas, 1)
                .then((result) => {
                    let tabela = result.dado;
                    console.log("tabela");
                    console.log(tabela);
                    setDadosPagamento({
                        qtdLiga: qtdPago,
                        valorSemDesconto: (tabela.valor_Unitario * qtdPago),
                        descontoDado: descontoRecebido,
                        valorPago: valorPago,
                        qtdLigaSelecionada: ids.length,
                        premiacao: valorPremiacao,
                        valorLiga: tabela.valor_Unitario,
                        desconto: ((qtdLigas * tabela.valor_Unitario) - (qtdLigas * tabela.valor)),
                        valorTotal: valorPremiacao + (qtdLigas <= 4 ? ((ids.length * tabela.valor_Unitario) - ((qtdLigas * tabela.valor_Unitario) - ((qtdLigas * tabela.valor) + descontoRecebido))) : (ids.length * tabela.valor))
                    });
                    setIsLoading(false);
                    setRemoveLoading(true);
                    return;
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os arquivos, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }
        setIsLoading(false);
        setRemoveLoading(true);

    }

    const handleGerarSolicitacao = () => {

        // if (formaPagamento === 0) {
        //     setRemoveLoading(true);
        //     setShowModalMensagem(true);
        //     setDadosModalMensagem({
        //         acao: true,
        //         label: "",
        //         tipo: "info",
        //         mensagem: "Favor informar a forma de pagamento!",
        //         display: "none",
        //         titulo: "Ateção"
        //     });
        //     return;
        // }

        // if (nomeCompleto.length === 0 || nomeCompleto.split(" ").length <= 1) {
        //     setRemoveLoading(true);
        //     setShowModalMensagem(true);
        //     setDadosModalMensagem({
        //         acao: true,
        //         label: "",
        //         tipo: "info",
        //         mensagem: "Favor informar nome completo!",
        //         display: "none",
        //         titulo: "Ateção"
        //     });
        //     return;
        // }
        // if (cpf.length < 14) {
        //     setRemoveLoading(true);
        //     setShowModalMensagem(true);
        //     setDadosModalMensagem({
        //         acao: true,
        //         label: "",
        //         tipo: "info",
        //         mensagem: "Favor informar CPF completo!",
        //         display: "none",
        //         titulo: "Ateção"
        //     });
        //     return;
        // }


        setIsLoading(true);
        setRemoveLoading(false);
        const user = CookieService.get("access_user");
        let statusSolicitacao = statusFinanceiro.find(f => f.codigo === 2)?.codigo;
        const dadosSalvar: IListaDadosCadastroFinanceiro[] = [];
        listaLigas.forEach((element: number) => {
            var dados = lstFinanceiro.find(f => f.codigo_Unico === element);
            if (dados !== undefined) {
                dadosSalvar.push({
                    codigo_Liga: dados.codigo_Liga,
                    codigo_Temporada: dados?.codigo_Temporada,
                    forma_Pagamento: formaPagamento,
                    codigo_Usuario: codigoUsuario,
                    codigo_Premiacao: 0,
                    codigo_Franquia: dados?.codigo_Franquia,
                    valor: Number(dadosPagamento?.valorTotal) / listaLigas.length,
                    situacao: true,
                    status: statusSolicitacao ?? 2,
                    desconto: (Number(dadosPagamento?.desconto) + Number(dadosPagamento?.descontoDado)) / listaLigas.length,
                    observacao: "-",
                    codUsuCriacao: user.codUsuario,
                });
            }
        });

        let dadosCreateFinaneiro: IDadosCreateFinanceiro = {
            codigo_Usuario: user.codUsuario,
            forma_Pagamento: formaPagamento,
            nome: nomeCompleto,
            cpf: cpf,
            dados_Financeiro: dadosSalvar
        };

        FinanceiroService.Create(dadosCreateFinaneiro)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: `Solicitação realizada com sucesso!`, // ${formaPagamento === 1 ? "segue abaixo o boleto para download ou o código de barras para copiar e colar!" : formaPagamento === 4 ? "segue abaixo o QRCode para leitura ou a chave pix para copiar e colar!" : " Entraremos em contato via e-mail."} ,
                    display: "none",
                    titulo: "Sucesso"
                });
                let urlCheckout = result.dado.url_Checkout ?? result.dado.url_Checkout
                setTimeout(() => {
                    handleDirecionarUrlPagamento(urlCheckout);
                    navigate(0);
                }, 3000);

            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível realizar a solicitação! Favor tentar mais tarde e caso o problema persista, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleDirecionarUrlPagamento = async (url: any) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        // Safety check for popup blockers
        if (newWindow) {
            newWindow.focus();
        }
        return;

    }

    const handleCarregarUrl = async (codigoFinanceiro: number) => {
        await FinanceiroService.getUrlPagamento(codigoFinanceiro)
            .then((result) => {
                const newWindow = window.open(result.dado, '_blank', 'noopener,noreferrer');
                // Safety check for popup blockers
                if (newWindow) {
                    newWindow.focus();
                }
                return;
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível gerar o pagamento, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const handleExcluirArquivo = async (params: any) => {
        if (Number(user.codUsuario) !== codigoUsuario) {
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Não é possível excluir esse arquivo com o seu usuário!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        await FinanceiroService.deleteById(params.codigo, Number(user.codUsuario))
            .then((result) => {
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Arquivo excluido com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });

                CarregarArquivosSalvos(Number(user.codUsuario), codigoTemporada);
                return;
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os arquivos, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const handleDonwload = async (params: any) => {
        const link = document.createElement("a");
        link.download = params.nome;
        link.href = params.caminho;
        link.target = "blank";

        link.click();
    }

    const handleBaixaPagamento = async (params: any) => {
        let dados: IDadosBaixaFinanceiro = {
            codigo: params.codigo,
            codUsuModificacao: user.codUsuario
        }

        if (params.status === 1) {

            setDadosModalEvent({
                acao: true,
                label: "Baixar Pagamento",
                tipo: "info",
                mensagem: `Baixa no pagamento da liga ${params.nome_Liga} para a franquia ${params.nome_Franquia} do usuário  ${params.nome_Usuario} `,
                display: "none",
                titulo: "FINANCEIRO",
                evento: "baixaFinanceiro",
                info: {
                    codigoLiga: params.codigo_Liga,
                    codigoUsuario: params.codigo_Usuario,
                    codigoFranquia: params.codigo_Franquia,
                    codigoTemporada: params.codigo_Temporada,
                    formaPagamento: params.forma_Pagamento,
                    codUsuCriacao: user.codUsuario,
                    valor: 0,
                    desconto: 0,
                    mensagemAdicional: "",
                    style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
                }
            });
            setShowModalEvent(true);

        }
        else {
            await FinanceiroService.updateByFinanceiroId(dados)
                .then((result) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Baixa realizada com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível realizar a baixa do pagamento, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }
        setRedirecionar("0");
    }

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    const detalhesColumns: GridColDef[] = [
        {
            field: 'codigo_Liga',
            headerName: 'CÓD.',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 50 : 50,
            maxWidth: UtilidadeService.isMobile() ? 60 : 60,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'descricao_Temporada',
            headerName: 'ANO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 80,
            maxWidth: UtilidadeService.isMobile() ? 70 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'descricao_Tipo',
            headerName: 'TIPO',
            flex: 1,
            minWidth: 70,
            sortable: false,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',

        },
        {
            field: 'nome_Liga',
            headerName: 'LIGA',
            flex: 1,
            //minWidth: 140,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: 140,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'premiacao',
            headerName: 'PRÊMIO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 80,
            maxWidth: UtilidadeService.isMobile() ? 70 : 85,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (!params.value ? "NÂO" : "SIM")
        },
        {
            field: 'valor_Usuario',
            headerName: 'VAL. PRÊMIO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (formatNumber.format(params.value)),
        },
        {
            field: 'valor',
            headerName: 'PAGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            maxWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            headerAlign: "right",
            align: "right",
            renderCell: (params) => params.value !== undefined && params.row.status === 5 ? formatNumber.format(params.value) : formatNumber.format(0),
        },
        {
            field: 'status',
            headerName: 'SITUAÇÃO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',

            renderCell: (params) => {
                const color = params.row.status >= 5 ? "#66bb6a" : params.row.status < 5 && params.row.status > 1 ? "#4864E8" : "auto";
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            textWrap: 'wrap'
                        }}
                    >
                        {statusFinanceiro.find(f => f.codigo === params.value)?.descricao}
                    </Box>
                );
            },
            //renderCell: (params) => (statusFinanceiro.find(f => f.codigo === params.value)?.descricao)
        },
        {
            field: 'actions',
            headerName: 'AÇÃO',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            minWidth: 80,
            hideable: !userAdm,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Dar Baixa"><Icon sx={{ color: params.row.status >= 5 ? "gray" : "#66bb6a" }}>payments</Icon></Tooltip>}
                    label="Upload"
                    onClick={() => handleBaixaPagamento(params.row)}
                    //showInMenu
                    disabled={params.row.status >= 5}
                />,
                // <GridActionsCellItem
                //     icon={<Tooltip title="Donwload"><Icon sx={{ color: "#E91309" }}>download</Icon></Tooltip>}
                //     label="Donwload"
                //     onClick={() => handleDonwload(params.row)}
                // />
            ]
        }
    ];

    const filesColumns: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'nome',
            headerName: 'NOME',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'actions',
            headerName: 'AÇÃO',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Donwload"><Icon sx={{ color: "#66bb6a" }}>download</Icon></Tooltip>}
                    label="Donwload"
                    onClick={() => handleDonwload(params.row)}

                />,
                <GridActionsCellItem
                    icon={<Tooltip title="Excluir"><Icon sx={{ color: !user.administrador && user.codUsuario !== codigoUsuario ? "darkgray" : "#E91309" }}>cancel</Icon></Tooltip>}
                    label="Excluir"
                    onClick={() => handleExcluirArquivo(params.row)}
                    disabled={!user.administrador && user.codUsuario !== codigoUsuario}

                />
            ]
        }
    ];

    const detalhesColumnsComissario: GridColDef[] = [
        {
            field: 'codigo_Usuario',
            headerName: 'CÓDIGO',
            minWidth: UtilidadeService.isMobile() ? 70 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'nome_Usuario',
            headerName: 'USUÁRIO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'status',
            headerName: 'SITUAÇÃO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                const color = params.row.status >= 5 ? "#66bb6a" : params.row.status < 5 && params.row.status > 1 ? "#4864E8" : "auto";

                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {statusFinanceiro.find(f => f.codigo === params.value)?.descricao}
                    </Box>
                );
            },
        }
    ];

    const indicacaoColumns: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '#',
            minWidth: UtilidadeService.isMobile() ? 70 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'nome',
            headerName: 'USUÁRIO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'quantidade_Indicacoes',
            headerName: 'QUANTIDADE',
            minWidth: UtilidadeService.isMobile() ? 70 : 120,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            cellClassName: 'super-app-theme--cell',
            headerAlign: 'center',
        },
        // {
        //     field: 'email',
        //     headerName: 'EMAIL',
        //     flex: 1,
        //     minWidth: UtilidadeService.isMobile() ? 120 : 220,
        //     sortable: UtilidadeService.isMobile() ? false : true,
        //     editable: false,
        //     headerClassName: 'super-app-theme--header',
        //     headerAlign: "center",
        //     align: "center",
        //     renderCell: (params) => {
        //         return (
        //             <Box
        //                 sx={{
        //                     whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
        //                 }}
        //             >
        //                 {params.value}
        //             </Box>
        //         );
        //     },
        // },
        {
            field: 'indicacoes',
            headerName: 'INDICAÇÕES',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 160 : 320,
            headerClassName: 'super-app-theme--header',
            align: 'left',
            cellClassName: 'super-app-theme--cell',
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            display: "flex",
                            alignSelf: "left",
                            paddingTop: "5px",
                            "& .MuiDataGrid-cell": {
                                display: "flex",
                            }
                        }}
                    >
                        <Grid size={{ xs: 12 }} display={"grid"} alignSelf={"center"}>
                            {params.row.indicacoes.map((m: any) => `${m.nome} - ${dayjs(m.data).format('DD/MM/YYYY HH:mm')}`).join(', \n')}
                        </Grid>
                    </Box>
                );
            }
        },
    ];



    const handleInputChangeImage = async (e: ChangeEvent<HTMLInputElement>) => {
        setShowModalMensagem(false);
        setIsLoading(true);
        setRemoveLoading(false);
        if (e.target.files) {
            let files = Array.from(e.target.files);
            await FinanceiroService.upLoadFiles(files)
                .then((result) => {
                    const dados = result.data.dado;
                    let dadosFinanceiros: IDadosSalvarArquivos[] = [];
                    dados.map(element => {
                        let dados = {
                            codigo_Liga: codigoLiga !== undefined ? Number(codigoLiga) : 0,
                            codigo_Temporada: codigoTemporada,
                            codigo_Usuario: codigoUsuario !== Number(user.codUsuario) ? codigoUsuario : Number(user.codUsuario),
                            nome: element.nome,
                            codUsuCriacao: Number(user.codUsuario)
                        };

                        dadosFinanceiros.push(dados);
                    });
                    RealizarCadastroArquivos(dadosFinanceiros);

                    // CarregarArquivosSalvos(Number(user.codUsuario), codigoTemporada);

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os arquivos, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }
    };

    const CarregarArquivosSalvos = async (codigoUsuario: number, codigoTemporada: number) => {
        await FinanceiroService.getArquivosFinanceiro(codigoUsuario, codigoTemporada)
            .then((result) => {
                const dados = result.dado;
                setFiles(dados);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const RealizarCadastroArquivos = async (dadosFinanceiros: IDadosSalvarArquivos[]) => {
        await FinanceiroService.createFiles(dadosFinanceiros)
            .then((result) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                const dados = result;
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Arquivo(s) salvo(s) com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                CarregarArquivosSalvos(Number(user.codUsuario), codigoTemporada);
                return;
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const inputRef = useRef<HTMLInputElement>(null);
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const handleLimparFiltros = () => {
        setCodigoTemporadaFiltro(0);
        setCodigoTemporadaFiltroHistorico(0);
        setCodigoTemporadaFinanceiroFiltro(0);
        setCodigoTipoLigaFiltro(0);
        setCodigoTipoLigaFiltroHistorico(0);
        setShowBotaoCancelar(false);
        handleCarregarUsuarios(true);
        setSelectedIdComplete(0);
        setLimparFiltros(true);
        setShowBotaoGerarSolicitacao(false);
        CarregarDadosFinanceiroHistorico(codigoUsuario);

    }

    const handleCopy = async (value: string) => {
        try {
            await navigator.clipboard.writeText(value);
            setOpenSnackbar(true);
        } catch (err) {
            console.error('Falha ao copiar o texto: ', err);
            setShowModalMensagem(true);
            setIsLoading(false);
            setRemoveLoading(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "success",
                mensagem: "Erro ao copiar o texto!",
                display: "none",
                titulo: "Atenção"
            });
            return

        }
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const handleRedirecionarWhatsApp = () => {
        const numero = "5531983163115";
        const mensagem = "Preciso de suporte para pagamento.";
        const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;
        window.open(url, "blank", "noopener,noreferrer");
    }

    return (
        <LayoutBaseDePagina
            titulo={`Financeiro - ${dadosLiga?.nome}`}
            //showLogoImg={dadosLiga?.caminho_Logo !== undefined ? dadosLiga?.caminho_Logo : showImagemFranquia}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoSalvar={false}
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => voltarAdm ? navigate("/adm/usuarios") : navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid container display="initial" alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} onChange={handleChangeTabs}>
                                        <Tab label="Minha Conta" {...a11yProps(0)} />
                                        <Tab label="Financeiro Liga"
                                            //disabled={!comissarioLiga}
                                            {...a11yProps(1)} />
                                        <Tab label="Histórico" {...a11yProps(2)} />
                                        <Tab label="Indicação" sx={{ display: user.administrador ? "block" : "none" }} {...a11yProps(3)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    <Grid container size={{ xs: 12, sm: 12 }}>
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} paddingBottom={3}>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                {!removeLoading && isLoading && <Loading />}
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} >
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} padding={1}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Temporadas"
                                                            disabled={true}
                                                            value={codigoTemporadaFiltro}
                                                            //onChange={(e) => { setCodigoTemporadaFiltro(Number(e.target.value)); }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                lstTemporadas.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} padding={1} display={"none"}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tipo Liga</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Tipo Liga"
                                                            value={codigoTipoLigaFiltro}
                                                            onChange={(e) => { setCodigoTipoLigaFiltro(Number(e.target.value)); }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                tiposLiga.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"none"} justifyContent="center" justifyItems="center" padding={1}>
                                                    <Button
                                                        color="error"
                                                        variant="contained"
                                                        disableElevation
                                                        style={{ height: "38px", alignSelf: "center", display: showBotaoCancelar ? "flex" : "none" }}
                                                        onClick={() => handleLimparFiltros()}
                                                        endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>clear</Icon>}>
                                                        <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} >Limpar</span>
                                                    </Button>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"none"} justifyContent="center" justifyItems="center" padding={1}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        style={{ height: "38px", alignSelf: "center" }}
                                                        onClick={() => { setShowBotaoCancelar(true); CarregarDadosFinanceiro(codigoUsuario, codigoTemporada) }}
                                                        endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>search</Icon>}>
                                                        <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} >Pesquisar</span>
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} marginTop={2} paddingTop={2}  >
                                                {detalheFinanceiro !== null && detalheFinanceiro !== undefined &&
                                                    <Card key={`Card${detalheFinanceiro?.codigo_Usuario}`} sx={{ border: "2px solid", borderColor: "#303134", m: 1, width: "100%" }}>
                                                        <CardActionArea onClick={() => { handleCarregarDetalhesFinanceiro(detalheFinanceiro?.detalhes_Financeiro_Liga); setShowDetalheFinanceiro(true); }}>
                                                            <CardContent sx={{ backgroundColor: "#252525", color: "white" }} >
                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} display="flex" flexDirection="column" alignSelf="center">
                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            <img src={detalheFinanceiro?.foto_Usuario} alt={detalheFinanceiro?.nome_Usuario} width={UtilidadeService.isMobile() ? 90 : 150} height={UtilidadeService.isMobile() ? 90 : 150} />
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" flexDirection="column" >
                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px" }} >
                                                                                MEUS DADOS
                                                                            </Typography>
                                                                            <Typography variant="body1" sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, fontWeight: "bold", padding: "3px" }}>
                                                                                Nome: {detalheFinanceiro?.nome_Usuario}
                                                                            </Typography>
                                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, fontWeight: "bold", padding: "3px" }}>
                                                                                Quantidade Ligas: {detalheFinanceiro?.quantidade_Liga}
                                                                            </Typography>
                                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, fontWeight: "bold", padding: "3px" }}>
                                                                                Valor por Liga: {detalheFinanceiro?.valor_Liga !== undefined ? formatNumber.format(Number(detalheFinanceiro?.valor_Liga)) : 0}
                                                                            </Typography>
                                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, fontWeight: "bold", padding: "3px" }}>
                                                                                Valor Total: {detalheFinanceiro?.valor_Total_Liga !== undefined ? formatNumber.format(Number(detalheFinanceiro?.valor_Total_Liga)) : detalheFinanceiro?.valor_Total_Liga}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" flexDirection="column" >
                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px" }} >
                                                                                PREMIAÇÕES
                                                                            </Typography>
                                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }}>
                                                                                Liga(s) com Anel(éis):  {premiacaoAnel}
                                                                            </Typography>
                                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }}>
                                                                                Valor(es) do(s) Anel(éis):  {formatNumber.format(Number(valorPremiacaoAnel.toString()))}
                                                                            </Typography>
                                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }}>
                                                                                Liga(s) com Funko(s):  {premiacaoFunko}
                                                                            </Typography>
                                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }}>
                                                                                Valor do(s) Funco(s) : {formatNumber.format(Number(valorPremiacaoFunko.toString()))}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} display="flex" flexDirection="column" >
                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px" }} >
                                                                                VALORES
                                                                            </Typography>
                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, display: "flex", justifyContent: "flex-start", fontWeight: "bold", padding: "3px" }}>
                                                                                Total:  {detalheFinanceiro?.valor_Total_Liga !== undefined ? formatNumber.format(Number(detalheFinanceiro?.valor_Total_Liga)) : "0"}
                                                                            </Typography>
                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, display: "flex", justifyContent: "flex-start", fontWeight: "bold", padding: "3px" }}>
                                                                                Pago:  {detalheFinanceiro?.valor_Pago !== undefined ? formatNumber.format(Number(detalheFinanceiro?.valor_Pago)) : "0"}
                                                                            </Typography>
                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, display: "flex", justifyContent: "flex-start", fontWeight: "bold", padding: "3px" }}>
                                                                                Devido:  {detalheFinanceiro?.valor_Restante !== undefined ? formatNumber.format(Number(detalheFinanceiro?.valor_Restante)) : "0"}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} display="flex" flexDirection="column" >
                                                                        <Box width="100%" display="flex" flexDirection="column" >
                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, display: "flex", justifyContent: "center" }}>
                                                                                SITUAÇÃO
                                                                            </Typography>
                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, display: "flex", justifyContent: "center", alignSelf: "center" }}>
                                                                                <span style={{ color: 1 === 1 ? "green" : "red" }}>  Ativo </span>
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </CardContent>
                                                        </CardActionArea>
                                                    </Card>
                                                }
                                            </Grid>
                                        </Grid>
                                        {showDetalheFinanceiro &&
                                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" padding={1}>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Detalhes Financeiros</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    {!removeLoading && <Loading />}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                    <Box
                                                        sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            }
                                                        }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            autoHeight
                                                            getRowId={(rows) => rows.codigo_Unico}
                                                            rows={lstFinanceiro}
                                                            columns={detalhesColumns}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 20,
                                                                    },
                                                                },
                                                            }}
                                                            columnVisibilityModel={{ actions: userAdm, }}
                                                            pageSizeOptions={[20]}
                                                            disableRowSelectionOnClick
                                                            disableVirtualization
                                                            checkboxSelection
                                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                            onRowSelectionModelChange={(ids) => {
                                                                handleRowsSelection(ids);

                                                            }}
                                                            isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>

                                                {(showBotaoGerarSolicitacao || showBotaoContatoWhatsApp) && (
                                                    // <Grid container size={{xs:12, sm:12}} spacing={1} display="flex" textAlign="end" justifyItems="center" marginBottom={2} marginTop={2} >
                                                    //     <Typography variant="body1">{` O valor total a ser pago será ${dadosPagamento?.valorTotal} - com ${dadosPagamento?.desconto} de desconto  `}</Typography>
                                                    // </Grid>
                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} display="flex" textAlign={UtilidadeService.isMobile() ? "center" : "end"} alignItems={UtilidadeService.isMobile() ? "center" : "end"} flexDirection="column" marginTop={"15px"} paddingRight={UtilidadeService.isMobile() ? "8px" : "30px"}>
                                                        <Box width={UtilidadeService.isMobile() ? "88%" : "30%"} display="flex" flexDirection="column" boxShadow={4} padding={UtilidadeService.isMobile() ? 1 : 2} sx={{ color: "white", backgroundColor: "#4f4f4f", borderRadius: "9px" }}>
                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }} >
                                                                QTD. LIGA PAGO.: {moedaRealLocaleValue(Number(dadosPagamento?.qtdLiga).toString())}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }} >
                                                                TOTAL S/ DESCONTO: {formatNumber.format(Number(dadosPagamento?.valorSemDesconto.toString()))}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }}>
                                                                DESCONTO RECEBIDO: {formatNumber.format(Number(dadosPagamento?.descontoDado.toString()))}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }}>
                                                                VALOR PAGO: {formatNumber.format(Number(dadosPagamento?.valorPago.toString()))}
                                                            </Typography>
                                                            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                                                <hr />
                                                            </Grid>
                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, fontWeight: "bold", padding: "3px" }}>
                                                                VALOR POR LIGA: {formatNumber.format(Number(dadosPagamento?.valorLiga.toString()))}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, fontWeight: "bold", padding: "3px" }}>
                                                                QTD: {Number(dadosPagamento?.qtdLigaSelecionada).toString()}
                                                            </Typography>
                                                            <Typography variant="body1" sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, fontWeight: "bold", padding: "3px" }}>
                                                                DESCONTO: {formatNumber.format(Number(dadosPagamento?.desconto.toString()))}
                                                            </Typography>
                                                            <Typography variant="body1" sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 16, fontWeight: "bold", padding: "3px" }}>
                                                                PREMIAÇÃO: {formatNumber.format(Number(dadosPagamento?.premiacao.toString()))}
                                                            </Typography>
                                                            <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px" }}>
                                                                VALOR A PAGAR: {formatNumber.format(Number(dadosPagamento?.valorTotal.toString()))}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                )}
                                                <Grid container size={{ xs: 12, sm: 12 }}>
                                                    {!removeLoading && isLoading && <Loading />}
                                                </Grid>
                                                {showBotaoGerarSolicitacao && !showBotaoContatoWhatsApp &&
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} marginTop={2} >
                                                        <Grid size={{ xs: 12, sm: 12 }} sx={{ display: "none" }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Pagamento</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{ display: "none" }} >
                                                            <RadioGroup
                                                                isExternalLoading={isLoading}
                                                                items={enumFormasPagamento.filter(f => f.visible)}
                                                                name="formas_pagamento"
                                                                label="Formas Pagamento"
                                                                value={formaPagamento}
                                                                onChange={(e) => setFormaPagamento(Number(e.target.value))}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ display: "none" }} >
                                                            <VTextField
                                                                required
                                                                fullWidth
                                                                placeholder="Nome Completo"
                                                                name="nomeCompleto"
                                                                disabled={isLoading}
                                                                label="Nome Completo"
                                                                value={nomeCompleto}
                                                                onChange={e => { setNomeCompleto(e.target.value); }}

                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ display: "none" }} >
                                                            <VTextMaskCPF
                                                                fullWidth
                                                                name="cpf"
                                                                disabled={isLoading}
                                                                label="CPF"
                                                                type="text"
                                                                typeMask="currency"
                                                                value={cpf}
                                                                onChange={e => setCpf(e.target.value)}
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} marginTop={2} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={() => handleGerarSolicitacao()}
                                                                endIcon={<Icon>cash</Icon>}>
                                                                GERAR SOLICITAÇÃO
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                }
                                                {showBotaoContatoWhatsApp &&
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} marginTop={2} >
                                                        <Grid size={{ xs: 12, sm: 12 }} sx={{ display: "block" }} >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Pagamento</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12 }} sx={{ display: "block" }} >
                                                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                                                Para moradores de fora do Brasil, o pagamento dos valores pendentes deve ser solicitado pelo WhatsApp +55 (31) 98316-3115. 
                                                                Em caso de dúvidas, entre em contato com o comissário da sua liga.
                                                            </Typography>

                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} marginTop={2} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={() => handleRedirecionarWhatsApp()}
                                                                endIcon={<WhatsAppIcon/>}>
                                                                SUPORTE WHATSAPP
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                }

                                                {lstDetalhePagamentoLiga.filter(f => f.codigo_Forma_Pagamento === 4).length > 0 &&
                                                    lstDetalhePagamentoLiga.filter(f => f.codigo_Forma_Pagamento === 4).map((m) => //boleto 1 cartão credito 2 debito 3 pix 4 avista 5
                                                        <Card
                                                            // key={`Card${m.codigo_Unico}`} 
                                                            sx={{ border: "2px solid", borderColor: "#303134", m: 1, width: "100%" }}
                                                        >
                                                            <CardContent sx={{ backgroundColor: "#252525", color: "white" }} >
                                                                <Typography variant="h6" align="center">
                                                                    Forma de Pagamento: {enumFormasPagamento.find(f => f.codigo === m.codigo_Forma_Pagamento)?.label}
                                                                </Typography>
                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} display="flex" flexDirection="column" alignSelf="center">
                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px", marginBottom: "8px" }} >
                                                                                Para efetuar o pagamento leia o QRCode abaixo com o APP do seu banco.
                                                                            </Typography>
                                                                            {/* <QRCode value={m.qr_Code_Pix} size={256} />                                                                                 */}
                                                                            <QRCode value={"qrcode-h.c6pix.com/qrs2/v2/02NCh0JGFHx4Jmtc3N6gils7OHm4wMiQaHpWtfurtSZqy1Z11q"} size={200} />
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} display="flex" flexDirection="column" marginTop={3} >

                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            <Grid size={12} >
                                                                                {/* <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px" }} >
                                                                        COPIA E COLA
                                                                    </Typography> */}
                                                                                <TextField
                                                                                    defaultValue={0}
                                                                                    fullWidth
                                                                                    rows={3}
                                                                                    multiline={true}
                                                                                    type="text"
                                                                                    label="Copia e Cola"
                                                                                    value={"00020101021226990014br.gov.bcb.pix2577qrcode-h.c6pix.com/qrs2/v2/02NCh0JGFHx4Jmtc3N6gils7OHm4wMiQaHpWtfurtSZqy1Z11q520400005303986540560.005802BR5916REGRESSIVO TESTE6009Sao Paulo62070503***630455A8"}

                                                                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                                                />
                                                                            </Grid>
                                                                            <Grid size={{ xs: 12, sm: 3 }} paddingTop={2}>
                                                                                {/* {m.copia_Cola_Pix} */}
                                                                                {/* Botão do Material UI para copiar */}
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    onClick={() => handleCopy("00020101021226990014br.gov.bcb.pix2577qrcode-h.c6pix.com/qrs2/v2/02NCh0JGFHx4Jmtc3N6gils7OHm4wMiQaHpWtfurtSZqy1Z11q520400005303986540560.005802BR5916REGRESSIVO TESTE6009Sao Paulo62070503***630455A8")}
                                                                                    startIcon={<FileCopy />}
                                                                                >
                                                                                    Copiar Código (Texto)

                                                                                </Button>
                                                                            </Grid>
                                                                            {/* Snackbar do Material UI para feedback visual */}
                                                                            <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseSnackbar}>
                                                                                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                                                                                    Código copiado para a área de transferência!
                                                                                </Alert>
                                                                            </Snackbar>

                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </CardContent>
                                                        </Card>
                                                    )}
                                                {lstDetalhePagamentoLiga.filter(f => f.codigo_Forma_Pagamento === 1).length > 0 &&
                                                    lstDetalhePagamentoLiga.filter(f => f.codigo_Forma_Pagamento === 1).map((m) => //boleto 1 cartão credito 2 debito 3 pix 4 avista 5
                                                        <Card
                                                            // key={`Card${m.codigo_Unico}`} 
                                                            sx={{ border: "2px solid", borderColor: "#303134", m: 1, width: "100%" }}
                                                        >
                                                            <CardContent sx={{ backgroundColor: "#252525", color: "white" }} >
                                                                <Typography variant="h6" align="center">
                                                                    Forma de Pagamento: {enumFormasPagamento.find(f => f.codigo === m.codigo_Forma_Pagamento)?.label}
                                                                </Typography>
                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} display="flex" flexDirection="column" alignSelf="center">
                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            {/* <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px" }} >
                                                                                {m.codigo_Barra_Boleto}
                                                                            </Typography> */}
                                                                            <Grid size={12} >
                                                                                {/* <Typography variant="h6" sx={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, fontWeight: "bold", padding: "3px" }} >
                                                                        COPIA E COLA
                                                                    </Typography> */}
                                                                                <TextField
                                                                                    fullWidth
                                                                                    rows={1}
                                                                                    multiline={true}
                                                                                    type="text"
                                                                                    label="Codigo de Barras"
                                                                                    value={m.codigo_Barra_Boleto}
                                                                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                                                />
                                                                            </Grid>
                                                                            <Grid size={{ xs: 12, sm: 3 }} paddingTop={2}>
                                                                                {/* {m.copia_Cola_Pix} */}
                                                                                {/* Botão do Material UI para copiar */}
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    onClick={() => handleCopy(m.codigo_Barra_Boleto)}
                                                                                    startIcon={<FileCopy />}
                                                                                >
                                                                                    Copiar Código de Barras

                                                                                </Button>
                                                                            </Grid>
                                                                            {/* Snackbar do Material UI para feedback visual */}
                                                                            <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseSnackbar}>
                                                                                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                                                                                    Código copiado para a área de transferência!
                                                                                </Alert>
                                                                            </Snackbar>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" flexDirection="column" paddingTop={2}>
                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                            <Button
                                                                                variant="contained"
                                                                                color="success"
                                                                                startIcon={<Download />}
                                                                                onClick={() => handleDonwload({ nome: "Boleto", caminho: m.caminho_Arquivo_Boleto })}
                                                                            >
                                                                                Baixar Arquivo
                                                                            </Button>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </CardContent>
                                                        </Card>
                                                    )}
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" textAlign="center" justifyItems="center" marginBottom={2} marginTop={2} >
                                                    <Grid size={{ xs: 12, sm: 6 }} display={voltarAdm ? "flex" : "none"} >
                                                        <Button component="label" color="info" variant="contained" startIcon={<CloudUploadIcon />}>
                                                            Anexar Arquivo
                                                            <VisuallyHiddenInput type="file" multiple onChange={(e: ChangeEvent<HTMLInputElement>) => { handleInputChangeImage(e); }} />
                                                        </Button>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6 }} display={possuiArquivo ? "flex" : "none"} >
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            startIcon={<Icon>download</Icon>}
                                                        >
                                                            Baixar Arquivo
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                                {files.length > 0 && (
                                                    <>
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}  >
                                                            {!removeLoading && isLoading && <Loading />}
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" textAlign="start" justifyItems="center" marginBottom={2} marginTop={2} >
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Arquivos</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                    '& .MuiDataGrid-cell:focus': {
                                                                        outline: 'none',
                                                                    },
                                                                    '& .MuiDataGrid-cell:focus-within': {
                                                                        outline: 'none',
                                                                    }
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        autoHeight
                                                                        getRowId={(rows) => rows.nome}
                                                                        rows={files}
                                                                        columns={filesColumns}
                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 20,
                                                                                },
                                                                            }
                                                                        }}
                                                                        pageSizeOptions={[20]}
                                                                        disableRowSelectionOnClick
                                                                        disableVirtualization
                                                                        disableColumnSelector
                                                                        disableDensitySelector
                                                                        disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                        disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                        sx={{
                                                                            fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                        }
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={1} >
                                    <Grid container size={{ xs: 12, sm: 12 }}>
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} paddingBottom={3}>
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }}  >
                                                {!removeLoading && isLoading && <Loading />}
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                                                <Grid size={{ xs: 12, sm: 6 }} paddingTop={2} height="auto" width={"100%"}  >
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <InputLabel id="demo-simple-select-helper-label">Liga</InputLabel>
                                                        <Select
                                                            label="Liga"
                                                            labelId="demo-simple-select-helper-label"
                                                            id="demo-simple-select-helper"
                                                            value={codigoLigaSelecionado}
                                                            onChange={(e) => { setCodigoLigaSelecionado(Number(e.target.value)); hendleCarregarDadosPorDropLiga(Number(e.target.value)); }}
                                                            defaultValue={Number(codigoLiga)}
                                                            variant="filled"
                                                            sx={{ height: "42px", width: "100%" }}
                                                        >
                                                            {
                                                                lstLiga.map((liga, i) => <MenuItem key={`MenuItem${liga.codigo}${i}`} value={liga.codigo}>{`${liga.codigo} - ${liga.label}`}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} padding={1}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Temporadas"
                                                            value={codigoTemporadaFinanceiroFiltro}
                                                            onChange={(e) => { setCodigoTemporadaFinanceiroFiltro(Number(e.target.value)); CarregarTemporadasPorLiga(codigoLigaSelecionado, Number(e.target.value)); }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                lstTemporadasAtual.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <hr />
                                                    <Typography variant="h6"> SITUAÇÃO </Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            {`LIGA: ${codigoLigaSelecionado} ${lstLiga.find(f => f.codigo === codigoLigaSelecionado)?.label}`}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            PENDENTE:  {lstFinanceiroComissario.filter(f => f.status === 1).length}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            SOLICITADO:{lstFinanceiroComissario.filter(f => f.status < 5 && f.status > 1).length}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                                        <Typography sx={{ fontWeight: "bold", fontSize: UtilidadeService.isMobile() ? 12 : "auto" }}>
                                                            PAGO: {lstFinanceiroComissario.filter(f => f.status >= 5).length}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        }
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            autoHeight
                                                            getRowId={(rows) => rows.codigo_Usuario}
                                                            rows={lstFinanceiroComissario}
                                                            columns={detalhesColumnsComissario}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 32,
                                                                    },
                                                                },
                                                            }}
                                                            pageSizeOptions={[32]}
                                                            disableRowSelectionOnClick
                                                            disableVirtualization
                                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} spacing={1} paddingBottom={3}>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                {!removeLoading && isLoading && <Loading />}
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} >
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} padding={1}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Temporadas"
                                                            value={codigoTemporadaFiltroHistorico}
                                                            onChange={(e) => { setCodigoTemporadaFiltroHistorico(Number(e.target.value)); }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                lstTemporadas.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} padding={1}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tipo Liga</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Tipo Liga"
                                                            value={codigoTipoLigaFiltroHistorico}
                                                            onChange={(e) => { setCodigoTipoLigaFiltroHistorico(Number(e.target.value)); }}
                                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                        >
                                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                            {
                                                                tiposLiga.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                                    <Button
                                                        color="error"
                                                        variant="contained"
                                                        disableElevation
                                                        style={{ height: "38px", alignSelf: "center", display: showBotaoCancelar ? "flex" : "none" }}
                                                        onClick={() => handleLimparFiltros()}
                                                        endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>clear</Icon>}>
                                                        <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} >Limpar</span>
                                                    </Button>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        style={{ height: "38px", alignSelf: "center" }}
                                                        onClick={() => { setShowBotaoCancelar(true); CarregarDadosFinanceiroHistorico(codigoUsuario) }}
                                                        endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>search</Icon>}>
                                                        <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} >Pesquisar</span>
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {showDetalheFinanceiroHistorico ? (
                                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" padding={1}>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Detalhes Financeiros</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    {!removeLoading && <Loading />}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        }
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            autoHeight
                                                            getRowId={(rows) => rows.codigo_Unico}
                                                            rows={lstFinanceiroHistorico}
                                                            columns={detalhesColumns}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 20,
                                                                    },
                                                                },
                                                            }}
                                                            columnVisibilityModel={{ actions: false, }}
                                                            pageSizeOptions={[20]}
                                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                            onRowSelectionModelChange={(ids) => {
                                                                handleRowsSelection(ids);
                                                            }}
                                                            isRowSelectable={(params: GridRowParams) => params.row.status < 5}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }}>
                                                    {!removeLoading && isLoading && <Loading />}
                                                </Grid>
                                                {files.length > 0 && (
                                                    <>
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }}  >
                                                            {!removeLoading && isLoading && <Loading />}
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" textAlign="start" justifyItems="center" marginBottom={2} marginTop={2} >
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Arquivos</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                    '& .MuiDataGrid-cell:focus': {
                                                                        outline: 'none',
                                                                    },
                                                                    '& .MuiDataGrid-cell:focus-within': {
                                                                        outline: 'none',
                                                                    }
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        autoHeight
                                                                        getRowId={(rows) => rows.nome}
                                                                        rows={files}
                                                                        columns={filesColumns}
                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 20,
                                                                                },
                                                                            }
                                                                        }}
                                                                        pageSizeOptions={[20]}
                                                                        disableVirtualization
                                                                        disableColumnSelector
                                                                        disableDensitySelector
                                                                        disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                        disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                        sx={{
                                                                            fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                        )
                                            :
                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" >
                                                <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="flex-start" >
                                                    <Typography variant="body1">Informações não disponíveis!</Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <hr />
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={3}>
                                    <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} spacing={1} paddingBottom={3}>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                {!removeLoading && isLoading && <Loading />}
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} >
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} padding={1}>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <Autocomplete
                                                            size="small"
                                                            openText="Abrir"
                                                            closeText="Fechar"
                                                            noOptionsText="Sem opções"
                                                            loadingText="Carregando..."
                                                            disablePortal
                                                            options={opcoesAutoCompleteUsuario}
                                                            loading={isLoading}
                                                            disabled={isLoading}
                                                            value={autoCompleteSelectedOption}
                                                            onChange={(event, newValue) => (setSelectedIdComplete(newValue?.codigo), true)}
                                                            popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Usuários"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} padding={1}>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                                    <Button
                                                        color="error"
                                                        variant="contained"
                                                        disableElevation
                                                        style={{ height: "38px", alignSelf: "center", display: showBotaoCancelar ? "flex" : "none" }}
                                                        onClick={() => handleLimparFiltros()}
                                                        endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>clear</Icon>}>
                                                        <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} >Limpar</span>
                                                    </Button>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        style={{ height: "38px", alignSelf: "center" }}
                                                        onClick={() => { setShowBotaoCancelar(true); CarregarDadosIndicacao(codigoUsuarioFiltroIndicacao) }}
                                                        endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>search</Icon>}>
                                                        <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }} >Pesquisar</span>
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {showDetalheIndicacao ? (
                                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" padding={1}>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Indicações</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    {!removeLoading && <Loading />}
                                                </Grid>
                                                {lstIndicacao.length > 0 && (
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" textAlign="start" justifyItems="center" marginBottom={2} marginTop={2} >
                                                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                            <Box sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .MuiDataGrid-cell:focus': {
                                                                    outline: 'none',
                                                                },
                                                                '& .MuiDataGrid-cell:focus-within': {
                                                                    outline: 'none',
                                                                }
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    autoHeight
                                                                    getRowId={(rows) => rows.nome}
                                                                    rows={lstIndicacao}
                                                                    columns={indicacaoColumns}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 20,
                                                                            },
                                                                        }
                                                                    }}
                                                                    pageSizeOptions={[20]}
                                                                    disableVirtualization
                                                                    disableColumnSelector
                                                                    disableDensitySelector
                                                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 10 : 14,
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        )
                                            :
                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" >
                                                <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="flex-start" >
                                                    <Typography variant="body1">Informações não disponíveis!</Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <hr />
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid >
                </Box >
            </VForm >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >
    );
}


